module.exports = __webpack_public_path__ + "img/smiling-face.5a11ac4f.png";